import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { IconModule, OutletModule, PageComponentModule } from '@spartacus/storefront';
import { RouterModule } from '@angular/router';
import { KnBrSpotlightComponent } from './kn-br-spotlight.component';



@NgModule({
    imports: [
        CommonModule,
        OutletModule,
        RouterModule,
        IconModule,
        PageComponentModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ImageMapComponent: {
                    component: KnBrSpotlightComponent,
                },
            },
        } as CmsConfig),
        KnBrSpotlightComponent,
    ],
    exports: [
        KnBrSpotlightComponent
    ],
    providers: []
})
export class KnBrSpotlightModule { }
